import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading/loading.component';
import { MenuComponent } from './menu/menu.component';
import { DrawerModule } from 'primeng/drawer';
import { DividerModule } from 'primeng/divider';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ButtonModule } from 'primeng/button';
import { FooterComponent } from './footer/footer.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';



@NgModule({
  declarations: [LoadingComponent, MenuComponent,FooterComponent,PageNotFoundComponent],
  imports: [
    CommonModule,
    DrawerModule,
    DividerModule,
    PanelMenuModule,
    ButtonModule
  ],
  exports: [LoadingComponent, MenuComponent, FooterComponent]
})
export class ResourcesModule { }
